import { useTranslations } from 'next-intl';
import TranslatedInlineLink from './TranslatedInlineLink';

const GuestCard = () => {
  const t = useTranslations('loyalty');
  return (
    <div className="tw-bg-secondary-light tw-rounded-2xl ">
      <div className="tw-p-6">
        <h6 className="tw-mb-0 tw-text-center">
          {t.rich('commons.guestCard', {
            0: (c) => (
              <TranslatedInlineLink href="/login">{c}</TranslatedInlineLink>
            ),
            1: (c) => (
              <TranslatedInlineLink href="/signup">{c}</TranslatedInlineLink>
            ),
          })}
        </h6>
      </div>
    </div>
  );
};

export default GuestCard;
